<template>
  <div class="dispatch-page" ref="pageRoot">
    <div class="pool-card pool-card-fill">
      <div class="pool-header">
        <div class="pool-title-row">
          <a-tabs v-model="activeTab" class="header-tabs" @change="onTabChange">
            <a-tab-pane key="users" tab="后台账号" />
            <a-tab-pane key="roles" tab="角色权限" />
          </a-tabs>
        </div>
        <div class="pool-actions">
          <template v-if="activeTab === 'users'">
            <a-input
              v-model="userQuery.search_name"
              allow-clear
              class="query-input-sm"
              placeholder="姓名"
              @pressEnter="loadUsers"
            />
            <a-input
              v-model="userQuery.search_username"
              allow-clear
              class="query-input-sm"
              placeholder="登录账号"
              @pressEnter="loadUsers"
            />
            <a-button type="primary" icon="search" @click="loadUsers">查询</a-button>
            <a-button type="primary" icon="plus" @click="openUserCreate">新增账号</a-button>
          </template>
          <template v-else>
            <a-input
              v-model="roleQuery.name"
              allow-clear
              class="query-input"
              placeholder="角色名称"
              @pressEnter="loadRoles"
            />
            <a-button type="primary" icon="search" @click="loadRoles">查询</a-button>
            <a-button type="primary" icon="plus" @click="openRoleCreate">新增角色</a-button>
          </template>
        </div>
      </div>

      <div
        v-show="activeTab === 'users'"
        class="table-host"
        ref="tableHostUsers"
        :style="tableHostStyle"
      >
        <div class="table-body-wrap" :style="tableBodyStyle">
          <a-table
            rowKey="id"
            class="sticky-table"
            :columns="userColumns"
            :dataSource="userList"
            :loading="userLoading"
            :pagination="false"
            :scroll="{ x: 900, y: tableScrollY }"
          >
            <template slot="state" slot-scope="text">
              <a-tag :color="Number(text) === 0 ? 'green' : 'default'">
                {{ Number(text) === 0 ? "正常" : "禁用" }}
              </a-tag>
            </template>
            <template slot="roles" slot-scope="text, record">
              <template v-if="record.roles && record.roles.length">
                <a-tag v-for="role in record.roles" :key="role.id" color="blue">{{ role.name }}</a-tag>
              </template>
              <span v-else class="text-muted">未分配</span>
            </template>
            <template slot="userAction" slot-scope="text, record">
              <a @click="openUserEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="openUserRoleAssign(record)">分配角色</a>
              <a-divider type="vertical" />
              <a @click="openResetPassword(record)">重置密码</a>
            </template>
          </a-table>
        </div>
        <div class="table-pagination">
          <a-pagination
            :current="userQuery.current"
            :pageSize="userQuery.size"
            :total="userTotal"
            show-size-changer
            :showTotal="(t) => `共 ${t} 条`"
            @change="onUserPageChange"
            @showSizeChange="onUserSizeChange"
          />
        </div>
      </div>

      <div
        v-show="activeTab === 'roles'"
        class="table-host"
        ref="tableHostRoles"
        :style="tableHostStyle"
      >
        <div class="table-body-wrap" :style="tableBodyStyle">
          <a-table
            rowKey="id"
            class="sticky-table"
            :columns="roleColumns"
            :dataSource="roleList"
            :loading="roleLoading"
            :pagination="false"
            :scroll="{ x: 900, y: tableScrollY }"
          >
            <template slot="available" slot-scope="text">
              <a-tag :color="Number(text) === 1 ? 'green' : 'default'">
                {{ Number(text) === 1 ? "起效" : "失效" }}
              </a-tag>
            </template>
            <template slot="roleAction" slot-scope="text, record">
              <a @click="openRoleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="openMenuAssign(record)">分配菜单</a>
              <a-divider type="vertical" />
              <a @click="toggleRoleAvailable(record)">
                {{ Number(record.available) === 1 ? "停用" : "启用" }}
              </a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除该角色吗？" @confirm="removeRole(record)">
                <a style="color: #ff4d4f">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
        <div class="table-pagination">
          <a-pagination
            :current="roleQuery.current"
            :pageSize="roleQuery.size"
            :total="roleTotal"
            show-size-changer
            :showTotal="(t) => `共 ${t} 条`"
            @change="onRolePageChange"
            @showSizeChange="onRoleSizeChange"
          />
        </div>
      </div>
    </div>

    <a-modal
      :visible="userVisible"
      :title="userForm.id ? '编辑账号' : '新增账号'"
      :confirmLoading="userSaving"
      @ok="submitUser"
      @cancel="userVisible = false"
    >
      <a-form-model ref="userFormRef" :model="userForm" :rules="userRules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item label="登录账号" prop="username">
          <a-input v-model="userForm.username" :disabled="!!userForm.id" placeholder="登录用户名" />
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="userForm.name" placeholder="显示名称" />
        </a-form-model-item>
        <a-form-model-item label="手机号">
          <a-input v-model="userForm.mobile" placeholder="选填" />
        </a-form-model-item>
        <a-form-model-item v-if="!userForm.id" label="密码" prop="password">
          <a-input
            v-model="userForm.password"
            type="password"
            autocomplete="new-password"
            placeholder="至少8位，含大小写数字特殊字符"
          />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="userForm.state">
            <a-radio :value="0">正常</a-radio>
            <a-radio :value="1">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      :visible="pwdVisible"
      title="重置密码"
      :confirmLoading="pwdSaving"
      @ok="submitResetPassword"
      @cancel="pwdVisible = false"
    >
      <a-form-model ref="pwdFormRef" :model="pwdForm" :rules="pwdRules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item label="登录账号">
          <a-input v-model="pwdForm.username" disabled />
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="password">
          <a-input
            v-model="pwdForm.password"
            type="password"
            autocomplete="new-password"
            placeholder="至少8位，含大小写数字特殊字符"
          />
        </a-form-model-item>
        <a-form-model-item label="确认密码" prop="confirmPassword">
          <a-input
            v-model="pwdForm.confirmPassword"
            type="password"
            autocomplete="new-password"
            placeholder="请再次输入新密码"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      :visible="roleVisible"
      :title="roleForm.id ? '编辑角色' : '新增角色'"
      :confirmLoading="roleSaving"
      @ok="submitRole"
      @cancel="roleVisible = false"
    >
      <a-form-model ref="roleFormRef" :model="roleForm" :rules="roleRules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item label="角色名称" prop="name">
          <a-input v-model="roleForm.name" placeholder="如：调度员" />
        </a-form-model-item>
        <a-form-model-item label="描述">
          <a-input v-model="roleForm.description" placeholder="角色说明" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="roleForm.available">
            <a-radio :value="1">起效</a-radio>
            <a-radio :value="0">失效</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-drawer
      :visible="roleDrawerVisible"
      :title="roleDrawerTitle"
      width="520"
      :destroyOnClose="true"
      @close="roleDrawerVisible = false"
    >
      <dispatch-user-role-assign
        v-if="roleDrawerVisible"
        :key="roleAssignUserId"
        :user-id="roleAssignUserId"
        :username="roleAssignUsername"
        :name="roleAssignName"
        @saved="onUserRoleSaved"
      />
    </a-drawer>

    <a-drawer
      :visible="menuDrawerVisible"
      :title="menuDrawerTitle"
      width="520"
      :destroyOnClose="true"
      @close="menuDrawerVisible = false"
    >
      <dispatch-role-menu-tree v-if="menuDrawerVisible" :key="menuRoleId" :role-id="menuRoleId" />
    </a-drawer>
  </div>
</template>

<script>
import { dispatchApi } from "./dispatchApi";
import { calcStickyTableLayout } from "./tableLayout";
import DispatchRoleMenuTree from "./DispatchRoleMenuTree.vue";
import DispatchUserRoleAssign from "./DispatchUserRoleAssign.vue";

const emptyUser = () => ({
  id: null,
  username: "",
  name: "",
  mobile: "",
  password: "",
  state: 0,
});

const emptyRole = () => ({
  id: null,
  name: "",
  description: "",
  available: 1,
});

export default {
  name: "DispatchAccountManage",
  components: { DispatchRoleMenuTree, DispatchUserRoleAssign },
  data() {
    return {
      activeTab: "users",
      userLoading: false,
      roleLoading: false,
      userSaving: false,
      roleSaving: false,
      userVisible: false,
      pwdVisible: false,
      pwdSaving: false,
      pwdForm: {
        userId: null,
        username: "",
        password: "",
        confirmPassword: "",
      },
      roleVisible: false,
      menuDrawerVisible: false,
      menuDrawerTitle: "分配菜单",
      menuRoleId: null,
      roleDrawerVisible: false,
      roleDrawerTitle: "分配角色",
      roleAssignUserId: null,
      roleAssignUsername: "",
      roleAssignName: "",
      userList: [],
      roleList: [],
      userTotal: 0,
      roleTotal: 0,
      tableScrollY: 400,
      tableHostStyle: {},
      tableBodyStyle: {},
      userQuery: { search_name: "", search_username: "", current: 1, size: 10 },
      roleQuery: { name: "", current: 1, size: 10 },
      userForm: emptyUser(),
      roleForm: emptyRole(),
      userColumns: [
        { title: "登录账号", dataIndex: "username", width: 140 },
        { title: "姓名", dataIndex: "name" },
        { title: "手机号", dataIndex: "mobile", width: 130 },
        { title: "角色", key: "roles", width: 180, scopedSlots: { customRender: "roles" } },
        { title: "状态", dataIndex: "state", width: 90, scopedSlots: { customRender: "state" } },
        { title: "创建时间", dataIndex: "createTime", width: 170 },
        { title: "操作", key: "action", width: 220, fixed: "right", scopedSlots: { customRender: "userAction" } },
      ],
      roleColumns: [
        { title: "角色名称", dataIndex: "name" },
        { title: "描述", dataIndex: "description", ellipsis: true },
        { title: "状态", dataIndex: "available", width: 90, scopedSlots: { customRender: "available" } },
        { title: "创建时间", dataIndex: "createTime", width: 170 },
        { title: "操作", key: "action", width: 260, fixed: "right", scopedSlots: { customRender: "roleAction" } },
      ],
      userRules: {
        username: [{ required: true, message: "请输入登录账号", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      pwdRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])[\da-zA-Z\W]{8,}$/,
            message: "至少8位，含大小写、数字和特殊字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.password) {
                callback(new Error("两次密码输入不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      roleRules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.loadUsers();
    this.loadRoles();
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.$nextTick(() => {
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(() => this.updateTableHeight());
        if (this.$refs.tableHostUsers) this.resizeObserver.observe(this.$refs.tableHostUsers);
        if (this.$refs.tableHostRoles) this.resizeObserver.observe(this.$refs.tableHostRoles);
      }
      if (this.$refs.pageRoot) {
        this.resizeObserverPage = new ResizeObserver(() => this.updateTableHeight());
        this.resizeObserverPage.observe(this.$refs.pageRoot);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.resizeObserverPage) this.resizeObserverPage.disconnect();
  },
  methods: {
    onTabChange() {
      this.$nextTick(this.updateTableHeight);
    },
    async loadUsers() {
      this.userLoading = true;
      try {
        const data = await dispatchApi.pageAdminUsers(this.userQuery);
        this.userList = data.records || [];
        this.userTotal = data.total || 0;
      } catch (e) {
        this.$message.error((e && e.message) || "加载账号失败");
        this.userList = [];
        this.userTotal = 0;
      } finally {
        this.userLoading = false;
        this.$nextTick(this.updateTableHeight);
      }
    },
    async loadRoles() {
      this.roleLoading = true;
      try {
        const data = await dispatchApi.pageRoles(this.roleQuery);
        this.roleList = data.records || [];
        this.roleTotal = data.total || 0;
      } catch (e) {
        this.$message.error((e && e.message) || "加载角色失败");
        this.roleList = [];
        this.roleTotal = 0;
      } finally {
        this.roleLoading = false;
        this.$nextTick(this.updateTableHeight);
      }
    },
    onUserPageChange(page, size) {
      this.userQuery.current = page;
      this.userQuery.size = size;
      this.loadUsers();
    },
    onUserSizeChange(current, size) {
      this.userQuery.current = 1;
      this.userQuery.size = size;
      this.loadUsers();
    },
    onRolePageChange(page, size) {
      this.roleQuery.current = page;
      this.roleQuery.size = size;
      this.loadRoles();
    },
    onRoleSizeChange(current, size) {
      this.roleQuery.current = 1;
      this.roleQuery.size = size;
      this.loadRoles();
    },
    openUserCreate() {
      this.userForm = emptyUser();
      this.userVisible = true;
    },
    openUserEdit(record) {
      this.userForm = {
        id: record.id,
        username: record.username,
        name: record.name,
        mobile: record.mobile || "",
        password: "",
        state: record.state != null ? record.state : 0,
      };
      this.userVisible = true;
    },
    openResetPassword(record) {
      this.pwdForm = {
        userId: record.id,
        username: record.username || "",
        password: "",
        confirmPassword: "",
      };
      this.pwdVisible = true;
      this.$nextTick(() => {
        if (this.$refs.pwdFormRef) this.$refs.pwdFormRef.clearValidate();
      });
    },
    submitResetPassword() {
      this.$refs.pwdFormRef.validate(async (valid) => {
        if (!valid) return;
        this.pwdSaving = true;
        try {
          await dispatchApi.resetAdminPassword(
            this.pwdForm.userId,
            this.pwdForm.username,
            this.pwdForm.password
          );
          this.$message.success("密码重置成功");
          this.pwdVisible = false;
        } catch (e) {
          this.$message.error((e && e.message) || "重置失败");
        } finally {
          this.pwdSaving = false;
        }
      });
    },
    openUserRoleAssign(record) {
      this.roleAssignUserId = record.id;
      this.roleAssignUsername = record.username || "";
      this.roleAssignName = record.name || "";
      this.roleDrawerTitle = `分配角色 — ${record.name || record.username || ""}`;
      this.roleDrawerVisible = true;
    },
    onUserRoleSaved() {
      this.roleDrawerVisible = false;
      this.loadUsers();
    },
    submitUser() {
      this.$refs.userFormRef.validate(async (valid) => {
        if (!valid) return;
        this.userSaving = true;
        try {
          if (this.userForm.id) {
            await dispatchApi.updateAdminUser(this.userForm);
            this.$message.success("更新成功");
          } else {
            await dispatchApi.createAdminUser(this.userForm);
            this.$message.success("创建成功");
          }
          this.userVisible = false;
          this.loadUsers();
        } catch (e) {
          this.$message.error((e && e.message) || "保存失败");
        } finally {
          this.userSaving = false;
        }
      });
    },
    openRoleCreate() {
      this.roleForm = emptyRole();
      this.roleVisible = true;
    },
    openRoleEdit(record) {
      this.roleForm = {
        id: record.id,
        name: record.name,
        description: record.description || "",
        available: record.available != null ? Number(record.available) : 1,
      };
      this.roleVisible = true;
    },
    openMenuAssign(record) {
      this.menuRoleId = record.id;
      this.menuDrawerTitle = `分配菜单 — ${record.name || ""}`;
      this.menuDrawerVisible = true;
    },
    submitRole() {
      this.$refs.roleFormRef.validate(async (valid) => {
        if (!valid) return;
        this.roleSaving = true;
        try {
          if (this.roleForm.id) {
            await dispatchApi.updateRole(this.roleForm);
            this.$message.success("更新成功");
          } else {
            await dispatchApi.createRole(this.roleForm);
            this.$message.success("创建成功");
          }
          this.roleVisible = false;
          this.loadRoles();
        } catch (e) {
          this.$message.error((e && e.message) || "保存失败");
        } finally {
          this.roleSaving = false;
        }
      });
    },
    async toggleRoleAvailable(record) {
      try {
        const next = Number(record.available) === 1 ? 0 : 1;
        await dispatchApi.updateRoleAvailable(record.id, next);
        this.$message.success("状态已更新");
        this.loadRoles();
      } catch (e) {
        this.$message.error((e && e.message) || "操作失败");
      }
    },
    async removeRole(record) {
      try {
        await dispatchApi.deleteRole(record.id);
        this.$message.success("删除成功");
        this.loadRoles();
      } catch (e) {
        this.$message.error((e && e.message) || "删除失败");
      }
    },
    updateTableHeight() {
      this.$nextTick(() => {
        const host = this.activeTab === "users" ? this.$refs.tableHostUsers : this.$refs.tableHostRoles;
        if (!host) return;
        const { scrollY, hostHeight } = calcStickyTableLayout(host, {
          theadH: 55,
          paginationH: 56,
          bottomGap: 20,
          minScrollY: 260,
          minHostH: 320,
        });
        this.tableScrollY = scrollY;
        this.tableHostStyle = { height: `${hostHeight}px` };
        this.tableBodyStyle = { "--table-scroll-y": `${scrollY}px` };
      });
    },
  },
};
</script>

<style scoped>
.dispatch-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  box-sizing: border-box;
  overflow: hidden;
}

.pool-card {
  background: #fff;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.pool-card-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.pool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1.25rem 0;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  gap: 1rem;
  flex-wrap: wrap;
}

.pool-title-row {
  display: flex;
  align-items: center;
  min-width: 200px;
}

.header-tabs {
  margin-bottom: -1px;
}

.header-tabs >>> .ant-tabs-bar {
  margin: 0;
  border-bottom: none;
}

.pool-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  padding-bottom: 0.75rem;
}

.query-input {
  width: 200px;
}

.query-input-sm {
  width: 140px;
}

.table-host {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 0.75rem 0.75rem;
  overflow: hidden;
}

.table-body-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.table-pagination {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 0.75rem;
  margin-top: 0.25rem;
  border-top: 1px solid #f1f5f9;
}

.sticky-table {
  height: 100%;
}

.sticky-table >>> .ant-spin-nested-loading,
.sticky-table >>> .ant-spin-container,
.sticky-table >>> .ant-table,
.sticky-table >>> .ant-table-content,
.sticky-table >>> .ant-table-scroll {
  height: 100%;
}

.sticky-table >>> .ant-table-body {
  max-height: var(--table-scroll-y, 400px) !important;
}

.text-muted {
  color: #94a3b8;
  font-size: 12px;
}
</style>
